import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import OnDayProcess from '../views/OnDayProcess.vue'
import Success from '../views/Success.vue'
import Fail from '../views/Fail.vue'
import QR from '../views/QR.vue'
import OpenDateProcess from "@/views/OpenDateProcess.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: OnDayProcess
  },
  {
    path: '/day',
    name: 'day',
    component: OnDayProcess
  },
  {
    path: '/opendate',
    name: 'opendate',
    component: OpenDateProcess
  },
  {
    path: '/success',
    name: 'success',
    component: Success
  },
  {
    path: '/fail',
    name: 'fail',
    component: Fail
  },
  {
    path: '/qr',
    name: 'qr',
    component: QR
  }
]

const router = createRouter({
  //history: createWebHashHistory(), // спользует # в пути , и сбербанк не может перенаправить на такой url клиента. И это нежелательно если встраивать в iFrame
  history: createWebHistory(), // не спользует # в пути
  routes
})

export default router
